<template>
  <div class="ds-control ds-myschedule-figure ds-no-padding">
    <div class="ds-myschedule-figure-day">
      <div
        class="ds-myschedule-figure-day-column"
        v-for="(column, columnIndex) in scheduleListNew"
        :key="columnIndex"
      >
        <div
          class="ds-myschedule-figure-day-column-plan"
          v-for="(plan, planIndex) in column"
          :key="planIndex"
          :style="planStyle(plan, scheduleListNew)"
          :title="getScheduleTitle(plan)"
          @click="goDetails(plan)"
        >
          <span class="ds-myschedule-figure-day-column-plan-name">
            [{{ plan.agendaTypeVo.name }}] </span
          >
          <span class="ds-myschedule-figure-day-column-plan-theme">
            {{ plan.theme }}
          </span>
        </div>
      </div>
      <div
        :style="nowTimeStyle"
        class="ds-myschedule-calendar-nowtime-hr"
      ></div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMyScheduleFigure",
  mixins: [$mixins.control],
  ctrlCaption: "个人日程-瀑布图",
  design: {
    isMask: false,
  },
  props: {
    nowTime: {
      type: String,
      default: "",
    },
    day: {
      type: String,
      default: "",
    },
    scheduleList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 跳转-新增、查看
    editPath: {
      type: String,
      default: "",
    },
  },

  data() {
    return {};
  },
  computed: {
    scheduleListNew: {
      get() {
        return this.reloadData(this.scheduleList);
      },
    },
    nowTimeStyle: {
      get() {
        let nowTime = this.nowTime;
        if (!nowTime)
          return {
            width: 0,
          };
        let startTime = dsf.date.format(new Date(), "yyyy-mm-dd");
        let timeCha =
          dsf.date.parse(startTime + " " + nowTime).getTime() -
          dsf.date.parse(startTime).getTime();
        return {
          top: (timeCha / 1000 / 60 / 60 / 25) * 100 + "%",
        };
      },
    },
  },
  created() {},

  methods: {
    planStyle(plan, list) {
      return (
        plan && {
          height: (plan.timeCha / 1000 / 60 / 60 / 24) * 100 + "%",
          top: (plan.startTimeByDayNumToDay / 1000 / 60 / 60 / 24) * 100 + "%",
          backgroundColor: plan.agendaTypeVo.colorValue + "10",
          borderLeft: "4px solid " + plan.agendaTypeVo.colorValue,
        }
      );
    },
    reloadData(date) {
      if (!this.day) return;
      let dateList = [[]];
      // 只显示非全天的日程
      let dayDateList = _.remove(_.cloneDeep(date), function (item) {
        return item.isDay != "1";
        // return item
      });
      dayDateList.forEach((item) => {
        item.startTimeByDayNum = dsf.date.parse(item.startTimeByDay).valueOf();
        item.startTimeByDayNumToDay =
          dsf.date.parse(item.startTimeByDay).valueOf() -
          dsf.date.parse(this.day + " 00:00:00").valueOf();
        item.endTimeByDayNum = dsf.date.parse(item.endTimeByDay).valueOf();
        item.timeCha = item.endTimeByDayNum - item.startTimeByDayNum;
      });
      let nowTimeNum = 0;
      let startTimeByDay = dsf.date.parse(this.day + " 00:00:00").valueOf();
      let endTimeByDay = dsf.date.parse(this.day + " 23:59:59").valueOf();
      while (dayDateList.length) {
        const { date, isWrap } = this.getDate(
          dayDateList,
          startTimeByDay,
          endTimeByDay
        );
        startTimeByDay = date.endTimeByDayNum + 1;
        if (isWrap) {
          startTimeByDay = date.endTimeByDayNum;
          dateList.push([]);
        }
        dateList[dateList.length - 1].push(date);
      }
      return dateList;
    },
    getDate(dayDateList, startTimeByDay, endTimeByDay) {
      let newDayDateList = dayDateList.filter((item) => {
        if (
          item.startTimeByDayNum >= startTimeByDay &&
          item.timeCha <= endTimeByDay - startTimeByDay
        ) {
          return true;
        }
        return false;
      });
      let isWrap = false;
      if (!newDayDateList.length) {
        isWrap = true;
        newDayDateList = _.cloneDeep(dayDateList);
      }
      newDayDateList.sort((a, b) => {
        return a.startTimeByDayNum - b.startTimeByDayNum;
      });
      let date = newDayDateList.shift();
      let index = dayDateList.findIndex((item) => item.id == date.id);
      dayDateList.splice(index, 1);
      return { date, isWrap };
    },
    goDetails(e) {
      let isview = e.isOwn == "1" ? "0" : "1";
      this.$openDialog({
        title: "查看日程",
        width: "80%",
        height: "70vh",
        params: {
          path:
            this.$replace(this.editPath) + "&isview=" + isview + "&id=" + e.id,
        },
      });
    },
    // 提示信息
    getScheduleTitle(plan) {
      if (!plan) return "";
      let { endTime, startTime, theme } = plan;
      let res = [theme, startTime + " - " + endTime];
      return res.join("\n");
    },
  },
});
</script>
